module.exports = __webpack_public_path__ + "img/video-player/wow-a22a49faaea4696e7e5ae4192ba48356.png";